import {omit} from "@pg-mono/nodash";

import {useGetOfferListQuery} from "../../api/get_offer_list";
import {IGetOfferListPayload} from "../../types/GetOfferListPayload";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";

interface IProps {
    latestQuery: IOfferListLatestQuery;
    isLastPage: boolean;
}

export const useFetchAdditionalOfferList = (props: IProps) => {
    const queryWithoutPrice = omit(props.latestQuery, ["price_0", "price_1", "instalment"]);
    const {fullQuery} = getFetchOfferListQueryData(queryWithoutPrice as Record<string, string | string[] | null>, true);

    const {data: offersWithoutPriceFilterData} = useGetOfferListQuery(fullQuery as IGetOfferListPayload, {
        skip: !props.isLastPage || !hasPriceFilter(props.latestQuery)
    });
    const offersWithoutPriceFilter = offersWithoutPriceFilterData?.results ?? [];

    return offersWithoutPriceFilter;
};
import {omit} from "@pg-mono/nodash";

import {useGetOfferListQuery} from "../../api/get_offer_list";
import {IGetOfferListPayload} from "../../types/GetOfferListPayload";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";

interface IProps {
    latestQuery: IOfferListLatestQuery;
    isLastPage: boolean;
}

export const useFetchAdditionalOfferList = (props: IProps) => {
    const queryWithoutPrice = omit(props.latestQuery, ["price_0", "price_1", "instalment"]);
    const {fullQuery} = getFetchOfferListQueryData(queryWithoutPrice as Record<string, string | string[] | null>, true);

    const {data: offersWithoutPriceFilterData} = useGetOfferListQuery(fullQuery as IGetOfferListPayload, {
        skip: !props.isLastPage || !hasPriceFilter(props.latestQuery)
    });
    const offersWithoutPriceFilter = offersWithoutPriceFilterData?.results ?? [];

    return offersWithoutPriceFilter;
};
